import type { EmailList } from '@/types/email'

export const EmailListFactory = {
  create: (data?: Partial<EmailList>): EmailList => ({
    id: data?.id,
    name: data?.name || '',
    frequency: data?.frequency || 'custom',
    tags: data?.tags || [],
    createdAt: data?.createdAt || new Date(),
    updatedAt: data?.updatedAt || new Date(),
    ...(data || {}),
  }),
}
